import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '@app/core/config/config.service';
import { AuthService } from '@app/core/guards/auth.service';
import { HttpService } from '@app/core/http/http.service';
import { ImportModel } from '@app/core/models/imports/import.model';
import { ImportDetailModel } from '@app/core/models/imports/import-detail.model';
import { ImportMissingInvoiceNumberDocumentSearchCriteriaModel } from '@app/core/models/imports/import-missing-invoice-number-searchcriteria.model';
import { ImportMissingInvoiceNumberDataSource } from '@app/core/models/imports/import-missing-invoice-number-data-source.model';
import { PagingParametersModel } from '@app/core/models/shared/paging-parameters.model';
import { ImportMissingInvoiceNumberModel } from '@app/core/models/imports/import-missing-invoice-number.model';

@Injectable({
    providedIn: 'root'
})
export class ImportService extends HttpService {
    constructor(protected http: HttpClient, protected config: ConfigService, protected authService: AuthService) {
        super(http, config, authService, 'imports');
    }

    getImport(importId: number): Observable<ImportModel> {
        return this.invokeGet<ImportModel>(`${importId}`);
    }

    getImports(fromDate?: string, toDate?: string): Observable<ImportModel[]> {
        return this.invokeGet<ImportModel[]>('', { fromDate, toDate });
    }

    getImportDetails(importId: number): Observable<ImportDetailModel[]> {
        return this.invokeGet<ImportDetailModel[]>(`${importId}/details`);
    }

    getImportDetailPdfContent(importId: number, importDetailId: number): Observable<Blob> {
        return this.invokeGetFile(`${importId}/${importDetailId}/pdf`);
    }

    searchMissingInvoiceNumberDocuments(sort?: string, order?: string, page?: number, size?: number, importMissingInvoiceNumberDocumentSearchCriteria?: ImportMissingInvoiceNumberDocumentSearchCriteriaModel): Observable<ImportMissingInvoiceNumberDataSource> {
        const pagingParameters = new PagingParametersModel(sort, order, page + 1, size);
        return this.invokeGet<ImportMissingInvoiceNumberDataSource>('missing-invoice-numbers/search', importMissingInvoiceNumberDocumentSearchCriteria, pagingParameters);
    }

    getMissingInvoiceNumberDocument(importMissingInvoiceNumberDocumentId: number): Observable<ImportMissingInvoiceNumberModel> {
        return this.invokeGet<ImportMissingInvoiceNumberModel>(`missing-invoice-numbers/${importMissingInvoiceNumberDocumentId}`);
    }

    getMissingInvoiceNumberDocumentContent(importMissingInvoiceNumberDocumentId: number): Observable<Blob> {
        return this.invokeGetFile(`missing-invoice-numbers/document/${importMissingInvoiceNumberDocumentId}`);
    }

    getMissingInvoiceNumberDocuments(importMissingInvoiceNumberDocumentIds: number[], massDownloadRequest: string): Observable<Blob> {
        return this.invokeGetMultipleFiles(`missing-invoice-numbers/documents/${massDownloadRequest}`, importMissingInvoiceNumberDocumentIds );
    }

    pickImportMissingInvoiceNumberDocument(importMissingInvoiceNumberDocumentId: number): Observable<any> {
        return this.invokePut(null, `missing-invoice-numbers/pick/${importMissingInvoiceNumberDocumentId}`)
    }

    pickImportMissingInvoiceNumberDocuments(importMissingInvoiceNumberDocumentId: number[]): Observable<any> {
        return this.invokePut(null, `missing-invoice-numbers/pick`, { importMissingInvoiceNumberDocumentId: importMissingInvoiceNumberDocumentId })
    }

    unpickImportMissingInvoiceNumberDocument(importMissingInvoiceNumberDocumentId: number): Observable<any> {
        return this.invokePut(null, `missing-invoice-numbers/unpick/${importMissingInvoiceNumberDocumentId}`)
    }

    unpickImportMissingInvoiceNumberDocuments(importMissingInvoiceNumberDocumentId: number[]): Observable<any> {
        return this.invokePut(null, `missing-invoice-numbers/unpick`, { importMissingInvoiceNumberDocumentId: importMissingInvoiceNumberDocumentId })
    }

    updateMissingInvoiceNumberDocument(importMissingInvoiceNumberDocumentId: number, comment: string): Observable<any> {
        return this.invokePut({ Id: importMissingInvoiceNumberDocumentId, Comment: comment }, `missing-invoice-numbers/${importMissingInvoiceNumberDocumentId}`);
    }
}
